import { render } from "./PartnerCard.vue?vue&type=template&id=681bbc36&scoped=true"
import script from "./PartnerCard.vue?vue&type=script&lang=js"
export * from "./PartnerCard.vue?vue&type=script&lang=js"

import "./PartnerCard.vue?vue&type=style&index=0&id=681bbc36&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681bbc36"]])

export default __exports__